module.exports = __webpack_public_path__ + "static/media/complaint-card-icon.816ad0bf.svg";